import React from 'react';
import { oneOfType, number, string } from 'prop-types';

NumberedCircle.propTypes = {
  cx: number,
  cy: number,
  rotate: number,
  children: oneOfType([number, string]),
};

function NumberedCircle({ rotate, cx, cy, circleSize = 10, children}) {
  const circleRadius = 4;
  return (
    <g transform={`rotate(-${rotate} ${cx} ${cy})`}>
      <g transform={`translate(${cx} ${cy})`}>
        <circle
          style={{
            fill: '#F9A54E',
            strokeMiterlimit:10
          }}
          r={circleRadius}
        >
        </circle>
        <text
          dy=".4em"
          fontSize="5"
          stroke="#282827"
          letterSpacing="0.9"
          strokeWidth="0.5px"
          textAnchor="middle"
        >
          {children}
        </text>
      </g>
    </g>
  );
}

export default NumberedCircle;